export default "__VITE_ASSET__DCeILaZ0__"